import { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import {
  Grid,
  Paper,
  Button,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import DateFnsUtils from "@date-io/date-fns";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { Autocomplete } from "@material-ui/lab";
import { useLocation } from 'react-router-dom';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import LeaveService from "../../../services/LeaveService";
import DayService from "../../../services/DayService";
import { userDetailContext } from "../../../App";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import Message from "../../tools/Message";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";
import Box from '@mui/material/Box';
import { headerDataRH } from "../../../data/modules/hr-header";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";
import ConfirmationDialog from "../../tools/ConfirmationDialog";
import MotifAnnulationLeave from "../../tools/MotifAnnulationLeave";
import { CircularProgress } from "@material-ui/core";
import UserService from "../../../services/UserService";

const bullRed = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '5px', transform: 'scale(0.8)', color: 'red', fontSize: '20px' }}
  >
    *
  </Box>
)

const moment = extendMoment(Moment);

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    elevation: 0,
    maxHeight: "90vh",
    minHeight: "200px",
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
      width: "100%",
      maxWidth: "100%",
      borderRadius: 0,
    },
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  disabledSolde: {
    background: "rgb(235, 235, 228)",
    cursor: "default",
    pointerEvents: "none !important",
  },
  text: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  radioGroup: {
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
    width: "100%",
    flexWrap: "wrap",
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column-reverse",
      alignItems: "stretch",
      justifyContent: "center",
      gap: theme.spacing(1.5),
      padding: theme.spacing(2, 0),
      "& > button": {
        width: "100% !important",
        minHeight: "48px",
        fontSize: "16px",
        margin: "0 !important",
      },
      "& > div": {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1.5),
      },
    },
  },
  buttonWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: "column",
      width: "100%",
      "& > button": {
        width: "100%",
        minHeight: "48px",
      },
    },
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down('sm')]: {
      alignItems: "flex-start",
      marginBottom: theme.spacing(0.5),
    },
  },
  fieldContainer: {
    width: "100%",
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  alertContainer: {
    marginTop: theme.spacing(0.5),
  },
  actionSection: {
    width: "100%",
    marginTop: theme.spacing(2),
    borderTop: "1px solid #e0e0e0",
    paddingTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      paddingTop: theme.spacing(1.5),
    },
  },
  cancelButton: {
    backgroundColor: "#9e9e9e",
    color: "#ffffff",
    fontWeight: 600,
    minWidth: "120px",
    "&:hover": {
      backgroundColor: "#757575",
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: "100%",
    },
  },
  saveButton: {
    fontWeight: 600,
    minWidth: "140px",
    [theme.breakpoints.down('sm')]: {
      minWidth: "100%",
    },
  },
  confirmButton: {
    fontWeight: 600,
    minWidth: "140px",
    [theme.breakpoints.down('sm')]: {
      minWidth: "100%",
    },
  },
}));

function LeaveAdd(props) {
  const [beginDate, setBeginDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [radioBeginDate, setRadioBeginDate] = useState("morning");
  const [radioEndDate, setRadioEndDate] = useState("morning");
  const [isPriority, setIsPriority] = useState(false);
  const [motif, setMotif] = useState("");
  const [delta, setDelta] = useState();
  const [balanceAfter, setBalanceAfter] = useState();
  const [isvalid, setIsvalid] = useState(0);
  const [file, setFile] = useState(null);

  const [form, setForm] = useState({
    leave_type_id: "",
    delta: "",
    beginDate: "",
    radioBeginDate: "morning",
    endDate: "",
    radioEndDate: "morning",
    isPriority: "",
    balanceBefore: "",
    balanceAfter: "",
    duration: "",
    reason: "",
  });

  const [askedDayOff, setAskedDayOff] = useState(0);
  const [dayOffType, setDayOffType] = useState("");
  const [leave_type, setLeaveType] = useState([]);
  const [day, setDay] = useState([]);
  const [soldePrevisional, setSoldePrevisional] = useState(0);
  const [soldePrevisionalAfter, setSoldePrevisionalAfter] = useState(0);
  const [inputStyle, setInputStyle] = useState({
    border: '1px solid black'
  });
  const [inputStyle1, setInputStyle1] = useState({
    border: '1px solid black'
  });

  const [valid, setValid] = useState(false);
  const [validdebut, setValiddebut] = useState(false);
  const [beginDateNotMatch, setBeginDateNotMatch] = useState(false);
  const [dateBeginFormatNotMatch, setDateBeginFormatNotMatch] = useState(false);
  const [dateEndFormatNotMatch, setDateEndFormatNotMatch] = useState(false);
  const [dateBeginInDayNotCounted, setDateBeginInDayNotCounted] = useState(false);
  const [dateEndinDayNotCounted, setDateEndinDayNotCounted] = useState(false);
  const [balanceBefore, setBalanceBefore] = useState(0);
  const [balanceAfters, setBalanceAfters] = useState(0);
  const [realdelta, setRealdelta] = useState(0);
  const [afterdelta, setAfterdelta] = useState(0);
  const [message, setMessage] = useState({
    open: false,
    color: 'green',
    messageInfo: '',
  });
  const { open, color, messageInfo } = message;
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");
  const [leaveValide, setLeaveValide] = useState(0);
  const [idLeave, setIdLeave] = useState(0);

  const [isRealBalanceAlreadyConfigurate, setisRealBalanceAlreadyConfigurate] = useState(false);
  const [errorMessageForRealBalanceEmpty, seterrorMessageForRealBalanceEmpty] = useState("");

  const [isLeaveUpdated, setLeaveUpdated] = useState(false);
  const [isConfirmationFinal, setIsConfirmationFinal] = useState(false);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const contextData = useContext(userDetailContext);
  const navigate = useNavigate();
  const params = useParams();
  const [pendingleave, setPendingleave] = useState(0);
  const [pendingRealPaidLeaveDuration, setPendingRealPaidLeaveDuration] = useState(0);
  const [pendingRealPaidLeaveValidationDuration, setPendingRealPaidLeaveValidationDuration] = useState(0);
  const totalPendingDuration =
    Number(pendingRealPaidLeaveDuration) + Number(pendingRealPaidLeaveValidationDuration);

  const [confirmationDialog, setConfirmationDialog] = useState({
    openDialog: false,
    messageDialog: "Voulez vous vraiment annuler votre demande de congé ?",
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [isCancel, setIsCancel] = useState(false);
  const [openDialogueerreur, setOpenDialogueerreur] = useState(false);
  const [openDialoguejoursmax, setOpenDialoguejourmax] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [emptyMotif, setEmptyMotif] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [raison, setRaison] = useState('');
  const [codeobselete, setCodeobselete] = useState('');
  const [codeLeave, setCodeLeave] = useState('');
  const [fileObselete, setFileObselete] = useState('');
  const [fileRequest, setFileRequest] = useState('');

  const [isValidEdited, setIsValidEdited] = useState(false);
  const [confirmLeaveAdd, setConfirmLeaveAdd] = useState(false);

  const [loadingPlanning, setloadingPlanning] = useState(false);
  const [loadingValidate, setloadingValidate] = useState(false);
  const [isLeavePlanningUpdated, setisLeavePlanningUpdated] = useState(false);
  const [idLeavePlanningUpdated, setidLeavePlanningUpdated] = useState(false);

  const [isValidatorNumberConfigurate, setisValidatorNumberConfigurate] = useState(false);
  const [dayOffNumberWithoutValidation, setdayOffNumberWithoutValidation] = useState(false);

  const [affichedate, setAffichedate] = useState(false);
  const [datelist, setDatelist] = useState([]);

  function getDayLeave(beginDate, endDate) {
    var dateArray = [];
    var currentDate = moment(beginDate);
    var stopDate = moment(endDate);
    while (currentDate <= stopDate) {
      dateArray.push(moment(currentDate).format('YYYY-MM-DD'))
      currentDate = moment(currentDate).add(1, 'days');
    }
    return dateArray;
  }

  function getDayParameter(beginDate, endDate) {
    let count = 0;
    const tab = getDayLeave(beginDate, endDate);
    for (let j = 0; j < day.length; j++) {
      for (let i = 0; i < tab.length; i++) {
        if (day[j] == tab[i]) {
          count++;
        }
      }
    }
    return count;
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const idLeaveToUpdated = params.id ? params.id : "";
  const valide = params.valide;
  const idLeaveToValidate = params.idLeaveToValidate;

  function handleChangeLeave(isRealRequest = null) {
    setLoading(true);
    LeaveService.saveLeave(
      dayOffType,
      beginDate,
      radioBeginDate,
      endDate,
      radioEndDate,
      isPriority,
      delta,
      balanceAfter,
      askedDayOff,
      motif,
      isvalid,
      isValidEdited,
      file,
      idLeave,
      isRealRequest,
      isLeavePlanningUpdated,
      isValidatorNumberConfigurate,
      dayOffNumberWithoutValidation
    )
      .then((res) => {
        if (res && res.status === 200) {
          setMessage({ ...message, open: true, color: 'green', messageInfo: "Succès" });
          setLoading(false);
          setloadingPlanning(false);
          setloadingValidate(false);
          navigate("/me/leaves");
        } else {
          if (res.message == "") {
            setLoading(false);
            setloadingPlanning(false);
            setloadingValidate(false);
            setMessage({ ...message, open: true, color: 'red', messageInfo: "Erreur undefined" });
          } else {
            setLoading(false);
            setloadingPlanning(false);
            setloadingValidate(false);
           setDatelist(res.data);

            if (res.data.length === 0) {
                setAffichedate(false);
            } else {
                setAffichedate(true);
            }

          //  setMessage({ ...message, open: true, color: 'red', messageInfo: res.message });
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        setloadingPlanning(false);
        setloadingValidate(false);
        setMessage({ ...message, open: true, color: 'red', messageInfo: "Une erreur s'est produite. Veuillez réessayer" });
      });
  }

  function Daynumber(beginDate, endDate, radioBeginDate, radioEndDate) {
    if (beginDate !== undefined && endDate !== undefined && beginDate !== "" && endDate !== "") {
      LeaveService.getLeaveDay(beginDate, endDate).then((result) => {
        if (result && result.data !== undefined) {
          let daysOff = result.data;
          const countDay = getDayParameter(beginDate, endDate);
          if (countDay != null) {
            daysOff = daysOff - countDay;
          }
          if (radioBeginDate === "afternoon") {
            daysOff -= 0.5;
          }
          if (radioEndDate === "afternoon") {
            daysOff += 0.5;
          }
          setAskedDayOff(daysOff);
          calculatePrevisionalAndRealBalanceAfter(dayOffType, daysOff, isRealBalanceAlreadyConfigurate, balanceBefore, realdelta);
        } else {
          setAskedDayOff(0);
        }
      }).catch((error) => {
        setAskedDayOff(0);
      });
    } else {
      setAskedDayOff(0);
    }
  }

  const handleClose = () => {
    setOpenDialogueerreur(false);
  };

  const handleCloseList = () => {
    setAffichedate(false);
  };

  const handleCloseJourmax = () => {
    setOpenDialoguejourmax(false);
  };

  function calculatePrevisionalAndRealBalanceAfter(typeOfLeave, duration, isRealBalanceExist, previsionalBefore, realBefore) {
    if (!isRealBalanceExist) {
      if (typeOfLeave == 1 || typeOfLeave.trim() == "") {
        LeaveService.getRealBalanceAfter(duration).then((results) => {
          setAfterdelta(results.data);
          if (results.data < 0) {
            setInputStyle1({
              border: form.delta - duration < 0 ? '5px solid red' : 'none'
            })
          }
          else {
            setInputStyle1({
              border: form.delta - duration < 0 ? '2px solid  rgb(19, 62, 103)' : 'none'
            })
          }
        });
      } else {
        setBalanceAfters(previsionalBefore);
        setAfterdelta(realBefore);
      }
    } else {
      if (typeOfLeave == 1 || typeOfLeave.trim() == "") {
        const totalAfterDelta = realBefore - duration;
        setAfterdelta(totalAfterDelta);
        if (totalAfterDelta < 0) {
          setInputStyle1({
            border: '5px solid red'
          })
        } else {
          setInputStyle1({
            border: '2px solid  rgb(19, 62, 103)'
          })
        }
      } else {
        setBalanceAfters(previsionalBefore);
        setAfterdelta(realBefore);
      }
    }
  }

  function handleClick() {
    if (parseInt(askedDayOff, 10) < 0) {
      setMessage({ ...message, open: true, color: 'red', messageInfo: "Veuillez actualiser la page, car le nombre de jours demandé ne peut pas être négatif" });
    }
    else {
      if (!dateBeginFormatNotMatch && !dateEndFormatNotMatch &&
        !dateBeginInDayNotCounted && !dateEndinDayNotCounted) {
        if (!valid && !validdebut) {
          if (valide === "valide") {
            if (isCancel && askedDayOff === 0) {
              setConfirmationDialog({ ...confirmationDialog, openDialog: true });
            } else {
              if (leaveValide === 1) {
                handleChangeLeave(0);
              } else {
                handleChangeLeave(0);
              }
            }
          } else {
            const today = new Date();
            const targetDate = new Date('2024-12-30');
            if (today < targetDate && realdelta <= 6) {
              setMessage({ ...message, open: true, color: 'red', messageInfo: "Votre solde est inférieur ou égal au niveau minimum requis pour le congé annuel" });
            }
            else if (parseInt(askedDayOff, 10) > 15) {
              setOpenDialoguejourmax(true);
            }
            else {
              if (isLeavePlanningUpdated) {
                handleChangeLeave(0);
              } else {
                setConfirmLeaveAdd(true);
                setConfirmationDialog({ ...confirmationDialog, openDialog: true });
              }
            }
          }
        }
      }
    }
  }

  const classes = useStyles();

  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  function handleBeginDateChange(e) {
    const formattedDate = e.target.value;
    const debutDate = moment(formattedDate).format("YYYY-MM-DD");

    setForm({ ...form, beginDate: debutDate });
    setBeginDate(debutDate);
    Daynumber(formattedDate, form.endDate, radioBeginDate, radioEndDate);

    if (checkIfDateInDayNotCompted(debutDate)) {
      setDateBeginInDayNotCounted(true);
      setBeginDate(debutDate);
      setForm({ ...form, beginDate: debutDate });
    } else {
      setDateBeginInDayNotCounted(false);
      setBeginDateNotMatch(false);
      setDateBeginFormatNotMatch(false);

      if (isValidDate(formattedDate)) {
        if (moment(formattedDate).year() < 999) {
          setDateBeginFormatNotMatch(true);
        } else {
          if (form.endDate !== "" && form.endDate !== undefined && (debutDate < form.endDate)) {
            setValiddebut(false);
            setValid(false);
            const debutDateYear = new Date(formattedDate).getFullYear();
            const endDateYear = new Date(form.endDate).getFullYear();
            setForm({ ...form, beginDate: debutDate });

            if (debutDateYear === endDateYear) {
              setBeginDateNotMatch(false);
              if (valide === "valide") {
                if (beginDate === debutDate) {
                  setBeginDate(debutDate);
                  Daynumber(form.beginDate, form.endDate, radioBeginDate, radioEndDate);
                  setLeaveValide(0);
                  setIsValidEdited(false);
                } else {
                  Daynumber(debutDate, form.endDate, radioBeginDate, radioEndDate);
                  setBeginDate(debutDate);
                  setLeaveValide(1);
                  setFile(null);
                  setIsValidEdited(true);
                }
                setForm({ ...form, beginDate: debutDate });
              } else {
                if (form.endDate !== "") {
                  Daynumber(debutDate, form.endDate, radioBeginDate, radioEndDate);
                }
                setBeginDate(debutDate);
                setForm({ ...form, beginDate: debutDate });
              }
            } else if (debutDateYear !== endDateYear && debutDateYear.toString().length === 4) {
              setBeginDateNotMatch(true);
            }
          } else if (form.endDate !== "" && form.endDate !== undefined && (debutDate > form.endDate)) {
            setValiddebut(true);
          } else if (valide === "valide" && form.endDate !== "" && form.endDate !== undefined && debutDate == form.endDate) {
            if (radioBeginDate === radioEndDate) {
              setIsCancel(true);
              setValid(false);
              setBeginDate(debutDate);
              setForm({ ...form, beginDate: debutDate });
              Daynumber(debutDate, form.endDate, radioBeginDate, radioEndDate);
              setIsValidEdited(false);
            } else {
              Daynumber(debutDate, form.endDate, radioBeginDate, radioEndDate);
              setBeginDate(debutDate);
              setLeaveValide(1);
              setFile(null);
              setIsValidEdited(true);
            }
          } else {
            setBeginDate(debutDate);
            setForm({ ...form, beginDate: debutDate });
          }
        }
      }
    }
  }

  function handleEndDateChange(e) {
    const formatDte = e.target.value;
    const datefin = moment(formatDte).format("YYYY-MM-DD");
    setForm({ ...form, endDate: datefin });
    setEndDate(datefin);
    Daynumber(form.beginDate, formatDte, radioBeginDate, radioEndDate);

    if (checkIfDateInDayNotCompted(datefin)) {
      setEndDate(datefin);
      setForm({ ...form, endDate: datefin });
      setDateEndinDayNotCounted(true);
    } else {
      setDateEndinDayNotCounted(false);
      setDateEndFormatNotMatch(false);

      if (isValidDate(formatDte)) {
        if (moment(formatDte).year() < 999) {
          setDateEndFormatNotMatch(true);
        } else {
          if (form.beginDate !== "" && form.beginDate !== undefined && (beginDate < datefin)) {
            setValid(false);
            setValiddebut(false);

            if (valide === "valide") {
              if (endDate === datefin) {
                Daynumber(form.beginDate, datefin, radioBeginDate, radioEndDate);
                setEndDate(datefin);
                setLeaveValide(0);
                setIsValidEdited(false);
              } else {
                Daynumber(form.beginDate, datefin, radioBeginDate, radioEndDate);
                setEndDate(datefin);
                setLeaveValide(1);
                setFile(null);
                setIsValidEdited(true);
              }
              setForm({ ...form, endDate: datefin });
            } else {
              if (form.beginDate !== "") {
                Daynumber(form.beginDate, datefin, radioBeginDate, radioEndDate);
              }
              setEndDate(datefin);
              setForm({ ...form, endDate: datefin });
            }
          } else if (form.beginDate !== "" && form.beginDate !== undefined && beginDate > datefin) {
            setValid(true);
          } else if (valide === "valide" && form.beginDate !== "" && form.beginDate !== undefined && beginDate == datefin) {
            if (radioBeginDate === radioEndDate) {
              setIsCancel(true);
              setValid(false);
              setEndDate(datefin);
              setForm({ ...form, endDate: datefin });
              Daynumber(form.beginDate, datefin, radioBeginDate, radioEndDate);
              setIsValidEdited(false);
            } else {
              Daynumber(form.beginDate, datefin, radioBeginDate, radioEndDate);
              setEndDate(datefin);
              setLeaveValide(1);
              setFile(null);
              setIsValidEdited(true);
            }
          } else {
            setEndDate(datefin);
            setForm({ ...form, endDate: datefin });
          }
        }
      }
    }
  }

  const handleChangeMotif = (e, value) => {
    if (valide === "valide") {
      if (motif == value) {
        setMotif(value);
        setLeaveValide(0);
      } else {
        setMotif(value);
        setLeaveValide(1);
        setFile(null);
      }
    } else {
      setMotif(value);
    }
  };

  const handleChangeInputMotif = (e) => {
    setMotif(e.target.value)
  }

  const handleChangeDelta = (e) => {
    setDelta(e.target.value);
  };

  const handleChangeBalanceAfter = (e) => {
    setBalanceAfter(e.target.value);
  };

  useEffect(() => {
    localStorage.setItem('status', 0);
    setForm({
      leave_type_id: "",
      delta: "",
      beginDate: "",
      radioBeginDate: "morning",
      endDate: "",
      radioEndDate: "morning",
      isPriority: "",
      balanceBefore: "",
      balanceAfter: "",
      duration: "",
      reason: "",
    });

    setRadioBeginDate("morning");
    setRadioEndDate("morning");

    const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

    if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
      setisRealBalanceAlreadyConfigurate(propsInitialBalance);
    }

    LeaveService.getBalanceBefore().then((result) => {
      setBalanceBefore(result.data);
      localStorage.setItem("previsionalBefore", result.data);
    });

    LeaveService.pendingleave().then((result) => {
      setPendingleave(result.data);
    });
    LeaveService.getPendingRealPaidLeaveDuration().then((result) => {
      if (result && result.status) {
        setPendingRealPaidLeaveDuration(Number(result.data) || 0);
      }
    });
    LeaveService.getPendingRealPaidLeaveValidationDuration().then((result) => {
      if (result && result.status) {
        setPendingRealPaidLeaveValidationDuration(Number(result.data) || 0);
      }
    });

    const propsActualBalance = localStorage.getItem("realBefore");

    if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
      setRealdelta(propsActualBalance);
    }

    if (beginDate && endDate) {
      LeaveService.getLeavePrevisional(contextData.id, moment().format('YYYY-MM-DD'), beginDate).then((result) => {
        const previsionalLeave = result.data.data.reduce(function (sum, leave) {
          return sum + parseFloat(leave.duration);
        }, 0);
        setSoldePrevisional(form.delta - previsionalLeave)
      })
    }

    DayService.getDay().then((results) => {
      if (results && results.data) {
        setDay(results.data);
      }
    });

    LeaveService.getLeaveType().then((result) => {
      if (result && result.data) {
        setLeaveType(
          result.data.map((d) => {
            return { id: d.leave_type_id, label: d.name, desc: d.desc };
          })
        );
      }
    });

    if (idLeaveToUpdated) {
      setIdLeave(idLeaveToUpdated)
      setLeaveUpdated(true);
    }

    if (valide === "valide") {
      setIsConfirmationFinal(true);
      setIdLeave(idLeaveToValidate);
      if (leaveValide !== 1) {
        setIsvalid(1);
      } else if (leaveValide === 1) {
        setFile(null);
      }
    }

    if (valide === "editPlanning") {
      setIdLeave(idLeaveToValidate);
      setidLeavePlanningUpdated(idLeaveToValidate);
      setisLeavePlanningUpdated(true);
    }

    setInputStyle({
      border: form.delta - askedDayOff < 0 ? '5px solid black' : 'none'
    })
    setInputStyle1({
      border: form.delta - askedDayOff < 0 ? '5px solid black' : 'none'
    })

    UserService.checkValidatornumberByUserId(0).then((results) => {
      if (results && results.status) {
        setisValidatorNumberConfigurate(true);
        setdayOffNumberWithoutValidation(results.data.user_validator_number_dayNumberWithoutValidation);
      }
    });
  }, [location]);

  useEffect(() => {
    if (isRealBalanceAlreadyConfigurate) {
      DayService.getDay().then((results) => {
        if (results && results.data) {
          setDay(results.data);
        }
      });
    }
  }, [isRealBalanceAlreadyConfigurate]);

  useEffect(() => {
    if (isLeaveUpdated || idLeavePlanningUpdated) {
      const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

      if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
        setisRealBalanceAlreadyConfigurate(propsInitialBalance);
      }

      const propsActualBalance = localStorage.getItem("realBefore");

      if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
        setRealdelta(propsActualBalance);
      }

      LeaveService.getLeaveType().then((result) => {
        if (result && result.data) {
          setLeaveType(
            result.data.map((d) => {
              return { id: d.leave_type_id, label: d.name, desc: d.desc };
            })
          );
        }
      });

      LeaveService.getLeaveById(idLeave).then((info) => {
        setIsvalid(0);
        setFile(info.data.file);
        setDayOffType(info.data.leave_type_id);
        setMotif(info.data.reason);
        setRadioBeginDate(info.data.begin_time_session);
        setRadioEndDate(info.data.end_time_session);
        if (info.data.is_priority == 0) {
          setIsPriority(false);
        } else {
          setIsPriority(true);
        }
        setAskedDayOff(info.data.duration);
        setForm({
          id: idLeave,
          begin_time: info.data.begin_time,
          duration: info.data.duration,
          end_time: info.data.end_time,
          is_valid: info.data.is_valid,
          leave_id: info.data.leave_id,
          leave_type_id: info.data.leave_type_id,
          reason: info.data.reason,
          user_id: info.data.user_id,
          is_priority: info.data.is_priority,
        });
        const results = info.data.begin_time;
        const date = results.split(' ');
        const fin = info.data.end_time;
        const findate = fin.split(' ');
        setForm({
          beginDate: date[0],
          endDate: findate[0],
        });
        setBeginDate(date[0]);
        setEndDate(findate[0]);
        setOpenLoadingSimpleBackdrop(false);
        getPrevisionnalBalanceBefore(info.data.begin_time);
      });
    }
  }, [isLeaveUpdated, isLeavePlanningUpdated]);

  useEffect(() => {
    if (isConfirmationFinal) {
      setOpenLoadingSimpleBackdrop(true);

      const propsInitialBalance = localStorage.getItem("isInitialBalanceConfigurated");

      if (propsInitialBalance !== null && propsInitialBalance !== undefined && propsInitialBalance.trim().length !== 0) {
        setisRealBalanceAlreadyConfigurate(propsInitialBalance);
      }

      const propsActualBalance = localStorage.getItem("realBefore");

      if (propsActualBalance !== null && propsActualBalance !== undefined && propsActualBalance.trim().length !== 0) {
        setRealdelta(propsActualBalance);
      }

      LeaveService.getLeaveType().then((result) => {
        if (result && result.data) {
          setLeaveType(
            result.data.map((d) => {
              return { id: d.leave_type_id, label: d.name, desc: d.desc };
            })
          );
        }
      });

      LeaveService.getLeaveById(idLeaveToValidate).then((info) => {
        setFile(info.data.file);
        setDayOffType(info.data.leave_type_id);
        setMotif(info.data.reason);
        setRadioBeginDate(info.data.begin_time_session);
        setRadioEndDate(info.data.end_time_session);
        if (info.data.is_priority == 0) {
          setIsPriority(false);
        } else {
          setIsPriority(true);
        }
        setAskedDayOff(info.data.duration);
        setForm({
          id: idLeaveToValidate,
          begin_time: info.data.begin_time,
          duration: info.data.duration,
          end_time: info.data.end_time,
          is_valid: info.data.is_valid,
          leave_id: info.data.leave_id,
          leave_type_id: info.data.leave_type_id,
          reason: info.data.reason,
          user_id: info.data.user_id,
          is_priority: info.data.is_priority,
        });
        const results = info.data.begin_time;
        const date = results.split(' ');
        const fin = info.data.end_time;
        const findate = fin.split(' ');
        setForm({
          beginDate: date[0],
          endDate: findate[0],
        });
        setBeginDate(date[0]);
        setEndDate(findate[0]);
        setAskedDayOff(info.data.duration);
        setCodeLeave(info.data.leave_code);
        setFileRequest(info.data.file);
        setOpenLoadingSimpleBackdrop(false);
      });
    }
  }, [isConfirmationFinal]);

  useEffect(() => {
    if (dayOffType == 2) {
      setAfterdelta(realdelta);
      setSoldePrevisionalAfter(soldePrevisional)
    } else {
      if (dayOffType.trim().length !== 0) {
        calculatePrevisionalAndRealBalanceAfter(dayOffType, askedDayOff, isRealBalanceAlreadyConfigurate, balanceBefore, realdelta);
        setSoldePrevisionalAfter(soldePrevisional - askedDayOff);
      }
    }
  }, [dayOffType]);

  useEffect(() => {
    if (leaveValide !== 1) {
      setIsvalid(1);
    } else {
      setIsvalid(0);
    }
  }, [leaveValide])

  useEffect(() => {
    if (realdelta) {
      calculatePrevisionalAndRealBalanceAfter(dayOffType, askedDayOff, isRealBalanceAlreadyConfigurate, balanceBefore, realdelta);
      if (soldePrevisional) {
        setSoldePrevisionalAfter(soldePrevisional - askedDayOff);
      }
    }
  }, [askedDayOff]);

  useEffect(() => {
    if (form.endDate !== undefined && form.endDate.trim().length !== 0) {
      LeaveService.getLeaveType().then((result) => {
        if (result && result.data) {
          setLeaveType(
            result.data.map((d) => {
              return { id: d.leave_type_id, label: d.name, desc: d.desc };
            })
          );
        }
      });
    }
  }, [form.endDate]);

  useEffect(() => {
    if (askedDayOff != 0) {
      setSoldePrevisionalAfter(soldePrevisional - askedDayOff);
    }
  }, [soldePrevisional]);

  useEffect(() => {
    setInputStyle({
      border: soldePrevisionalAfter < 0 ? '5px solid red' : '2px solid  rgb(19, 62, 103)'
    })
  }, [soldePrevisionalAfter]);

  useEffect(() => {
    if (form.beginDate !== undefined && form.beginDate.trim().length !== 0) {
      getPrevisionnalBalanceBefore(form.beginDate);
    }
  }, [form.beginDate]);

  const handleRadioChange = (name) => (event) => {
    if (name === "begin") {
      if (valide === "valide") {
        if (radioBeginDate === event.target.value) {
          Daynumber(form.beginDate, form.endDate, event.target.value, radioEndDate);
          setRadioBeginDate(event.target.value);
          setLeaveValide(0);
        } else {
          Daynumber(form.beginDate, form.endDate, event.target.value, radioEndDate);
          setRadioBeginDate(event.target.value);
          setLeaveValide(1);
          setIsValidEdited(true);
        }
      } else {
        if (form.endDate !== undefined) {
          Daynumber(form.beginDate, form.endDate, event.target.value, radioEndDate);
        }
        setRadioBeginDate(event.target.value);
      }
    } else {
      if (valide === "valide") {
        if (radioEndDate === event.target.value) {
          Daynumber(form.beginDate, form.endDate, radioBeginDate, event.target.value);
          setRadioEndDate(event.target.value);
          setLeaveValide(0);
        } else {
          Daynumber(form.beginDate, form.endDate, radioBeginDate, event.target.value);
          setRadioEndDate(event.target.value);
          setLeaveValide(1);
          setIsValidEdited(true);
        }
      } else {
        setRadioEndDate(event.target.value);
        if (form.endDate !== undefined) {
          Daynumber(form.beginDate, form.endDate, radioBeginDate, event.target.value);
        }
      }
    }
  };

  const handleCheckChange = () => {
    setIsPriority(!isPriority)
  };

  const handleChangeType = (e) => {
    if (valide === "valide") {
      if (dayOffType === e.target.value) {
        setDayOffType(e.target.value);
        setLeaveValide(0);
      } else {
        setDayOffType(e.target.value);
        setLeaveValide(1);
      }
    } else {
      setDayOffType(e.target.value);
    }
  };

  function handleCancel() {
    navigate("/me/leaves");
  }

  function getPrevisionnalBalanceBefore(beginDate) {
    LeaveService.getPrevisonalBalance(beginDate).then((result) => {
      if (result && result.status) {
        setSoldePrevisional(result.data);
      }
    });
  }

  function confirmDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function closeDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  function cancelDialog() {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false });
  }

  const handleValidCancel = () => {
    setLoading(true);
    setEmptyMotif(false);
    if (raison && raison.trim().length !== 0 && raison !== undefined) {
      LeaveService.getLeaveObselete(raison, codeobselete, fileObselete, idLeaveToValidate).then((result) => {
        if (result != "") {
          if (result.status) {
            setCancel(false);
            setRaison("");
            setMessage({ ...message, openMessage: true, color: 'green', messageInfo: result.data.message });
            setEmptyMotif(false);
            navigate("/me/leaves");
          } else {
            setMessage({ ...message, openMessage: true, color: 'red', messageInfo: result.message });
          }
        } else {
          setMessage({ ...message, openMessage: true, color: 'red', messageInfo: "Une erreur s'est produite. Veuillez réessayer" });
        }
      }).catch((err) => {
        setMessage({ ...message, openMessage: true, color: 'red', messageInfo: 'erreur' });
      });
    } else {
      setEmptyMotif(true);
      setLoading(false);
    }
  };

  const handleCloseCancel = (event, reason) => {
    if (reason === "backdropClick") {
      return false;
    }
    setCancel(false);
  };

  function handleRaison(ev) {
    const { name, value } = ev.target;
    setRaison(ev.target.value);
    setEmptyMotif(false);
  };

  function handleCancelingLeave(id) {
    setConfirmationDialog({ ...confirmationDialog, openDialog: false, messageDialog: "Voulez-vous vraiment annuler la demande de congé" });
    setCancel(true);
    setCodeobselete(codeLeave);
    setFileObselete(fileRequest);
  }

  function checkIfDateInDayNotCompted(date) {
    if (day.includes(date)) {
      return true;
    } else {
      return false;
    }
  }

  function handleValidateLeaveDialog() {
    const leavefinaly = realdelta - pendingleave - askedDayOff;
    if (parseInt(leavefinaly) < 0) {
      setOpenDialogueerreur(true);
    } else {
      setloadingValidate(true);
      handleChangeLeave(1);
    }
  }

  function handleJustePlanningDialog() {
    setloadingPlanning(true);
    handleChangeLeave(0);
  }

  const isDisabled = !isRealBalanceAlreadyConfigurate ||
    dateBeginInDayNotCounted ||
    dateBeginFormatNotMatch ||
    dateEndFormatNotMatch ||
    dateEndinDayNotCounted;

  return (
    <MainContainer {...headerDataRH}>
      <ConfirmationDialog
        confirmLeaveAdd={confirmLeaveAdd}
        isCancel={isCancel}
        idLeave={idLeaveToValidate}
        openDialog={openDialog}
        messageDialog={messageDialog}
        closeDialog={closeDialog}
        confirmDialog={handleCancelingLeave}
        cancelDialog={cancelDialog}
        loadingPlanning={loadingPlanning}
        loadingValidate={loadingValidate}
        handleJustePlanningDialog={handleJustePlanningDialog}
        handleValidateLeaveDialog={handleValidateLeaveDialog}
        isValidatorNumberConfigurate={isValidatorNumberConfigurate}
        dayOffNumberWithoutValidation={dayOffNumberWithoutValidation}
        openDialogueerreur={openDialogueerreur}
        handleClose={handleClose}
        dayOffRequested={askedDayOff}
      />
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />

      <MotifAnnulationLeave
        openDialog={cancel}
        handleCloseCancel={handleCloseCancel}
        raison={raison}
        handleRaison={handleRaison}
        emptyMotif={emptyMotif}
        isLoading={isLoading}
        handleValidCancel={handleValidCancel}
      />

      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Paper className={classes.paper} variant="outlined">
          <Grid container spacing={2}>
            {/* Date de départ */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Date de départ{bullRed}</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <div className={classes.fieldContainer}>
                    <TextField
                      label="Date de départ"
                      type="date"
                      value={form.beginDate || ''}
                      onChange={handleBeginDateChange}
                      fullWidth
                      variant="outlined"
                      size="small"
                      color="primary"
                      error={validdebut}
                      InputLabelProps={{ shrink: true }}
                    />
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="position"
                        name="position"
                        value={radioBeginDate}
                        onChange={handleRadioChange("begin")}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value="morning"
                          control={<Radio color="primary" />}
                          label="Matin"
                        />
                        <FormControlLabel
                          value="afternoon"
                          control={<Radio color="primary" />}
                          label="Après-midi"
                        />
                      </RadioGroup>
                    </FormControl>
                    {validdebut && <Alert severity="error" className={classes.alertContainer}>La date de départ doit être inférieure à la date de retour</Alert>}
                    {beginDateNotMatch && <Alert severity="error" className={classes.alertContainer}>L'année de votre départ n'est pas conforme à celle du retour. Veuillez vérifier!</Alert>}
                    {dateBeginFormatNotMatch && <Alert severity="warning" className={classes.alertContainer}>La norme demandée pour la date c'est JJ/MM/AAAA). Veuillez vérifier!</Alert>}
                    {dateBeginInDayNotCounted && <Alert severity="warning" className={classes.alertContainer}>Votre date de départ est un jour férié ou weekend. Veuillez vérifier!</Alert>}
                  </div>
                </Grid>
              </Grid>
            </Grid>

            {/* Date de retour */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Date de retour{bullRed}</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <div className={classes.fieldContainer}>
                    <TextField
                      label="Date de retour"
                      type="date"
                      value={form.endDate || ''}
                      onChange={handleEndDateChange}
                      fullWidth
                      variant="outlined"
                      size="small"
                      color="primary"
                      InputLabelProps={{ shrink: true }}
                    />
                    <FormControl component="fieldset">
                      <RadioGroup
                        row
                        aria-label="position"
                        name="position"
                        value={radioEndDate}
                        onChange={handleRadioChange("end")}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value="morning"
                          control={<Radio color="primary" />}
                          label="Matin"
                        />
                        <FormControlLabel
                          value="afternoon"
                          control={<Radio color="primary" />}
                          label="Après-midi"
                        />
                      </RadioGroup>
                    </FormControl>
                    {valid && <Alert severity="error" className={classes.alertContainer}>La date de retour doit être supérieure à la date de départ</Alert>}
                    {dateEndFormatNotMatch && <Alert severity="warning" className={classes.alertContainer}>La norme demandée pour la date c'est JJ/MM/AAAA). Veuillez vérifier!</Alert>}
                    {dateEndinDayNotCounted && <Alert severity="warning" className={classes.alertContainer}>Votre date de retour est un jour férié ou weekend. Veuillez vérifier!</Alert>}
                  </div>
                </Grid>
              </Grid>
            </Grid>

            {/* Type de congé */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Type de congé{bullRed}</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <FormControl fullWidth size="small">
                    <Autocomplete
                      options={leave_type}
                      getOptionLabel={(option) => option.label}
                      value={leave_type.find(item => item.id === dayOffType) || null}
                      onChange={(event, newValue) => {
                        handleChangeType({
                          target: {
                            name: 'leave_type_id',
                            value: newValue ? newValue.id : ''
                          }
                        });
                      }}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Type"
                          variant="outlined"
                          size="small"
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.id === value?.id}
                      getOptionDisabled={(option) => option.label === "Autres"}
                      forcePopupIcon
                      openOnFocus
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            {/* Motif pour Congé Payé */}
            {dayOffType === "1" && (
              <>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.labelContainer}>
                        <label>Motif{bullRed}</label>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        disableClearable
                        onChange={handleChangeMotif}
                        inputValue={motif}
                        options={leave_type.map((option) => option.desc)}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onChange={handleChangeInputMotif}
                            label="Motif"
                            margin="normal"
                            variant="outlined"
                            InputProps={{ ...params.InputProps, type: "search" }}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.labelContainer}>
                        <label>Urgence</label>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                      <input
                        type="checkbox"
                        checked={isPriority}
                        onChange={handleCheckChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}

            {/* Motif pour Permission */}
            {dayOffType === "2" && (
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={4}>
                    <div className={classes.labelContainer}>
                      <label>Motif</label>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <Autocomplete
                      freeSolo
                      id="free-solo-2-demo"
                      disableClearable
                      onChange={handleChangeMotif}
                      inputValue={motif}
                      options={leave_type.map((option) => option.desc)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          onChange={handleChangeInputMotif}
                          label="Motif"
                          margin="normal"
                          variant="outlined"
                          InputProps={{ ...params.InputProps, type: "search" }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            {/* Solde réel avant */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Solde réel avant</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={realdelta}
                    name="delta"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Nombre de jour demandé */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Nombre de jour demandé</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    value={askedDayOff}
                    name="duration"
                    readOnly={true}
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Solde réel après */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Solde réel après</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={realdelta - askedDayOff}
                    name="delta"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Congé en attente */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Congé en attente/non confirmé</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={totalPendingDuration}
                    name="delta"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Ancien champ "Solde réel après validation"
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Solde réel après validation</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={realdelta - pendingleave}
                    name="delta"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>
            */}

            {/* Solde réel si confirmé */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>Solde réel si validé/confirmé</label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={realdelta - totalPendingDuration}
                    name="realBalanceAfterConfirmation"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Solde prévisionnel final */}
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={4}>
                  <div className={classes.labelContainer}>
                    <label>
                      Solde prévisionnel final (Solde réel si validé/confirmé et demande)
                    </label>
                  </div>
                </Grid>
                <Grid item xs={12} sm={8}>
                  <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    readOnly={true}
                    value={realdelta - totalPendingDuration - askedDayOff}
                    name="delta"
                    disabled={true}
                    className={classes.disabledSolde}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* Champs obligatoires */}
            <Grid item xs={12}>
              <label className={classes.text}>({bullRed}): Champs obligatoires</label>
            </Grid>

            {!isRealBalanceAlreadyConfigurate && (
              <Grid item xs={12}>
                <Alert severity="warning">{errorMessageForRealBalanceEmpty}</Alert>
              </Grid>
            )}

            <Spacer y={2} />

            <Grid item xs={12}>
              <div className={classes.actionSection}>
                {valide === "valide" ? (
                  <div className={classes.buttonContainer}>
                    <Button
                      variant="contained"
                      className={classes.cancelButton}
                      onClick={handleCancel}
                    >
                      ANNULER
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.confirmButton}
                      onClick={handleClick}
                      disabled={isDisabled}
                    >
                      {isLoading ? (
                        <>
                          <CircularProgress size={20} style={{ marginRight: 8 }} />
                          Chargement...
                        </>
                      ) : (
                        "CONFIRMER"
                      )}
                    </Button>
                  </div>
                ) : (
                  <div className={classes.buttonContainer}>
                    <Button
                      variant="contained"
                      className={classes.cancelButton}
                      onClick={handleCancel}
                    >
                      ANNULER
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.saveButton}
                      onClick={handleClick}
                      disabled={isDisabled}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} />
                      ) : (
                        "ENREGISTRER"
                      )}
                    </Button>
                  </div>
                )}
              </div>
            </Grid>

          </Grid>
        </Paper>
      </MuiPickersUtilsProvider>

      <BootstrapDialog
        onClose={handleCloseJourmax}
        aria-labelledby="customized-dialog-title"
        open={openDialoguejoursmax}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Nombre de jours de congé non autorisé
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseJourmax}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Vous ne pouvez demander des congés que pour une durée maximale de 15 jours.
          </Typography>
          <Typography gutterBottom>
            Veuillez ajuster votre demande en conséquence.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseJourmax}>
            D'accord, compris
          </Button>
        </DialogActions>
      </BootstrapDialog>

      {/* Dialogue erreur solde insuffisant */}
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={openDialogueerreur}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Solde de congés insuffisant
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Votre demande de congés ne peut pas être validée car elle entraînerait un solde de congés négatif.
          </Typography>
          <Typography gutterBottom>
            Veuillez vérifier votre solde restant et ajuster votre demande en conséquence.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            D'accord, compris
          </Button>
        </DialogActions>
      </BootstrapDialog>

      {/* Dialogue erreur date existant dans la base */}
      <BootstrapDialog
        onClose={handleCloseList}
        aria-labelledby="customized-dialog-title"
        open={affichedate}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Vous êtes déjà en congé pendant cette période
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseList}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
            Voici la liste des dates où vous êtes occupé. Veuillez les modifier si nécessaire au lieu d'en créer un nouveau.
          </Typography>
          <Box sx={{ mt: 2, overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: '#f5f5f5' }}>
                  <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Date de départ</th>
                  <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Date de retour</th>
                  <th style={{ padding: '8px', border: '1px solid #ddd', textAlign: 'left' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {datelist && datelist.length > 0 ? (
                  datelist.map((element, index) => (
                    <tr key={index}>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{element.date_debut || element.begin_time || '-'}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{element.date_fin || element.end_time || '-'}</td>
                      <td style={{ padding: '8px', border: '1px solid #ddd' }}>{element.statusPrevisionnel || element.status || '-'}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" style={{ padding: '8px', textAlign: 'center' }}>Aucune donnée disponible</td>
                  </tr>
                )}
              </tbody>
            </table>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCloseList}>
            D'accord, compris
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </MainContainer>
  );
}

export default LeaveAdd;